import React, { useState, useEffect } from 'react';
import {
    Box,
    Button,
    Table,
    Thead,
    Tbody,
    Tr,
    Th,
    Td,
    useDisclosure,
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalFooter,
    ModalBody,
    ModalCloseButton,
    FormControl,
    FormLabel,
    Input,
    IconButton,
    HStack,
    Link,
    Card,
    CardBody,
    Text,
    Stack,
    Flex,
    Select,
} from '@chakra-ui/react';
import { EditIcon, DeleteIcon } from '@chakra-ui/icons';
import { getAdminAllGuestInvites, getAdminAllGuests } from '../../service/api/event';
import QRCode from 'react-qr-code';

const Guest = () => {
    const { isOpen, onOpen, onClose } = useDisclosure();
    const [isEditing, setIsEditing] = useState(false);
    const [currentIndex, setCurrentIndex] = useState(null);
    const [entries, setEntries] = useState([]);
    const [totalGuests, setTotalGuests] = useState(0);
    const [totalGuestDecline, setTotalGuestDecline] = useState(0);
    const [totalPending, setTotalPending] = useState(0);
    const [data, setData] = useState([]);
    const [filter, setFilter] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);




    const intitalizeTable = async () => {
        const appResp = await getAdminAllGuests();

        if (appResp != null) {
            setEntries(appResp);
            setData(appResp);

            let totalConfirmed = 0;
            let totalDeclined = 0;
            let totalPending = 0;

            appResp.forEach(guest => {
                const mainGuest = 1;
                const allocatedGuests = guest.invite_rsvp.allocated_guests.length || 0;
                const confirmedAddtl = guest.confirmed_guests.length || 0;

                if (guest.response === "Yes") {
                    // Main guest confirmed + confirmed additional guests
                    totalConfirmed += mainGuest + confirmedAddtl;

                    // Unused allocated guests are treated as declined
                    const unused = allocatedGuests - confirmedAddtl;
                    totalDeclined += unused > 0 ? unused : 0;

                } else if (guest.response === "No") {
                    // Main guest declined + all allocated guests
                    totalDeclined += mainGuest + allocatedGuests;

                } else {
                    // No response → all pending
                    totalPending += mainGuest + allocatedGuests;
                }
            });

            setTotalGuests(totalConfirmed);
            setTotalGuestDecline(totalDeclined);
            setTotalPending(totalPending);
        }

    }


    const filteredData = data.filter(item =>
        (item.first_name || '').toLowerCase().includes(filter.toLowerCase()) ||
        (item.last_name || '').toLowerCase().includes(filter.toLowerCase()) ||
        (item.response || '').toLowerCase().includes(filter.toLowerCase())
    );
    const totalPages = Math.ceil(filteredData.length / itemsPerPage);
    const indexOfLastEntry = currentPage * itemsPerPage;
    const indexOfFirstEntry = indexOfLastEntry - itemsPerPage;
    const currentItems = filteredData.slice(indexOfFirstEntry, indexOfLastEntry);
    console.log(currentItems)

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    React.useEffect(() => {
        intitalizeTable();

    }, []);

    const [formValues, setFormValues] = useState({
        first_name: '',
        last_name: '',
        invite_code: '',
        email: '',
        contact_no: '',
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormValues({
            ...formValues,
            [name]: value,
        });
    };

    const handleAddEntry = () => {
        setEntries([...entries, formValues]);
        setFormValues({
            first_name: '',
            last_name: '',
            invite_code: '',
            email: '',
            contact_no: '',
        });
        onClose();
    };

    const handleEditEntry = (index) => {
        setIsEditing(true);
        setCurrentIndex(index);
        setFormValues(entries[index]);
        onOpen();
    };

    const handleUpdateEntry = () => {
        const updatedEntries = entries.map((entry, index) =>
            index === currentIndex ? formValues : entry
        );
        setEntries(updatedEntries);
        setFormValues({
            first_name: '',
            last_name: '',
            invite_code: '',
            email: '',
            contact_no: '',
        });
        setIsEditing(false);
        onClose();
    };

    const handleDeleteEntry = (index) => {
        const updatedEntries = entries.filter((_, i) => i !== index);
        setEntries(updatedEntries);
    };

    const filterChange = (filter) => {

        setFilter(filter);
        setCurrentPage(1);
        handlePageChange(1);
    }
    const pageItemsChange = (items) => {
        setItemsPerPage(items);
        setCurrentPage(1);
        handlePageChange(1);
    }


    return (
        <Box p={4}>
            <Box overflowX="auto">
                <Card>
                    <CardBody>
                        <Stack direction="column">
                            <Stack direction="row">
                                <Text as='b'>
                                    Total Confirmed Guests:
                                </Text>
                                <Text as='b' color="green">
                                    {totalGuests}
                                </Text>
                            </Stack>
                            <Stack direction="row">
                                <Text as='b'>
                                    Total Guests Declined:
                                </Text>
                                <Text as='b' color="red">
                                    {totalGuestDecline}
                                </Text>
                            </Stack>
                            <Stack direction="row">
                                <Text as='b'>
                                    Total Guests Pending:
                                </Text>
                                <Text as='b' color="orange">
                                    {totalPending}
                                </Text>
                            </Stack>
                        </Stack>


                    </CardBody>
                </Card>
            </Box>
            <Button onClick={onOpen} colorScheme="teal" mb={4}>
                Add Entry
            </Button>

            <Box overflowX="auto">
                <Input placeholder="Filter by first name, last name, or response"
                    value={filter}
                    onChange={(e) => filterChange(e.target.value)}
                    mb={4}
                />
            </Box>
            <Box overflowX="auto">
                <Stack direction="row">
                    <Select
                        value={itemsPerPage}
                        onChange={(e) => pageItemsChange(Number(e.target.value))}>
                        <option value={4}>
                            4
                        </option>
                        <option value={10}>
                            10
                        </option>
                        <option value={30}>
                            30
                        </option>
                        <option value={100}>
                            100
                        </option>
                        <option value={entries.length}>
                            Show All
                        </option>

                    </Select>
                </Stack>
                <Table variant="simple">
                    <Thead>
                        <Tr>
                            <Th>Response</Th>
                            <Th>First Name</Th>
                            <Th>Last Name</Th>
                            <Th>Confirmed Additional Guests</Th>
                            <Th>Reserved Additional Guests</Th>
                            <Th>Unique Code</Th>
                            <Th>Email</Th>
                            <Th>Contact No</Th>
                            <Th>Invitation Link</Th>
                            <Th>QR Code</Th>
                        </Tr>
                    </Thead>
                    <Tbody>
                        {currentItems.map((entry, index) => (

                            <Tr key={index}>
                                {/* <Td>
                                    <HStack>
                                        <IconButton
                                            aria-label="Edit"
                                            icon={<EditIcon />}
                                            onClick={() => handleEditEntry(index)}
                                        />
                                        <IconButton
                                            aria-label="Delete"
                                            icon={<DeleteIcon />}
                                            onClick={() => handleDeleteEntry(index)}
                                        />
                                    </HStack>
                                </Td> */}
                                <Td>{entry.response}</Td>
                                <Td>{entry.invite_rsvp.first_name}</Td>
                                <Td>{entry.invite_rsvp.last_name}</Td>
                                <Td>
                                    <Text as="b">
                                        ({entry.confirmed_guests.length})
                                    </Text>
                                    {entry.confirmed_guests
                                        .map(guest => guest.fullname)
                                        .join(', ')}
                                </Td>
                                <Td>
                                    <Text as="b">
                                        ({entry.invite_rsvp.allocated_guests.length})
                                    </Text>
                                    {entry.invite_rsvp.allocated_guests
                                        .map(guest => guest.fullname)
                                        .join(', ')}
                                </Td>
                                <Td>{entry.invite_rsvp.invite_code}</Td>
                                <Td>{entry.invite_rsvp.email}</Td>
                                <Td>{entry.invite_rsvp.contact_no}</Td>
                                <Td>
                                    <Link fontSize='xl' color='teal' href={"https://orijednallytheonefortonet.valg.dev/guest/respond/?invitecode=" + entry.invite_code}>{"https://orijednallytheonefortonet.valg.dev/guest/respond/?invitecode=" + entry.invite_code}
                                    </Link>
                                </Td>
                                <Td>
                                    <QRCode size={110} value={"https://orijednallytheonefortonet.valg.dev/guest/respond/?invitecode=" + entry.invite_code}>

                                    </QRCode></Td>
                            </Tr>
                        ))}
                    </Tbody>
                </Table>
            </Box>
            <Flex mt={4} justifyContent="space-between" flexWrap="wrap">
                <Button
                    onClick={() => handlePageChange(currentPage - 1)}
                    disabled={currentPage === 1}
                    width={{ base: '100%', md: 'auto' }}
                    mb={2}
                >
                    Previous
                </Button>
                <Button
                    onClick={() => handlePageChange(currentPage + 1)}
                    disabled={currentPage === totalPages}
                    width={{ base: '100%', md: 'auto' }}
                    mb={2}
                >
                    Next
                </Button>

            </Flex>
            <Modal isOpen={isOpen} onClose={onClose}>
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader>{isEditing ? 'Edit Entry' : 'Add New Entry'}</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                        <FormControl mb={4}>
                            <FormLabel>First Name</FormLabel>
                            <Input
                                name="first_name"
                                value={formValues.first_name}
                                onChange={handleChange}
                                placeholder="First Name" />
                        </FormControl>
                        <FormControl mb={4}>
                            <FormLabel>Last Name</FormLabel>
                            <Input
                                name="last_name"
                                value={formValues.last_name}
                                onChange={handleChange}
                                placeholder="Last Name" />
                        </FormControl>
                        <FormControl mb={4}>
                            <FormLabel>Unique Code</FormLabel>
                            <Input
                                name="invite_code"
                                value={formValues.invite_code}
                                onChange={handleChange}
                                placeholder="Unique Code" />
                        </FormControl>
                        <FormControl mb={4}>
                            <FormLabel>Email</FormLabel>
                            <Input
                                name="email"
                                value={formValues.email}
                                onChange={handleChange}
                                placeholder="Email" />
                        </FormControl>
                        <FormControl mb={4}>
                            <FormLabel>Contact No</FormLabel>
                            <Input
                                name="contact_no"
                                value={formValues.contact_no}
                                onChange={handleChange}
                                placeholder="Contact No" />
                        </FormControl>
                    </ModalBody>

                    <ModalFooter>
                        <Button colorScheme="teal" onClick={isEditing ? handleUpdateEntry : handleAddEntry}>
                            {isEditing ? 'Update' : 'Add'}
                        </Button>
                        <Button onClick={onClose} ml={3}>
                            Cancel
                        </Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>
        </Box>
    );
};

export default Guest;
